<script setup lang="ts">
import { computed, toRefs } from 'vue';
import type { DataTableCellProps } from '@common';
import type { ParcelStatData } from '../models';
import { useCropStore } from '@shared';

const props = defineProps<DataTableCellProps<any, ParcelStatData>>();
const { item } = toRefs(props);

const cropStore = useCropStore();

const cropName = computed(() => item.value.data.crop && cropStore.findCropNameByCode(item.value.data.crop));
</script>

<template>
  <div>{{ cropName }}</div>
</template>
